import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ApiInterface from "@/commons/api/ApiInterface";
import Background from "@/commons/pages/borders/background/Background";
import Header from "@/commons/pages/borders/header/Header";
import Footer from "@/commons/pages/borders/footer/Footer";
import style from "../logchat.module.css";

const SingleLogChatPrivate = () => {
    const { uuid } = useParams();
    const [logLines, setLogLines] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [nameSearch, setNameSearch] = useState("");
    const [startTime, setStartTime] = useState("00:00:00");
    const [endTime, setEndTime] = useState("23:59:59");
    const [fileName, setFileName] = useState("");
    const [publicFile, setPublicFile] = useState(null);

    let loadFileInfos = async () => {
        ApiInterface.getFileInfo(uuid).then(async info => {
            let {fileName, filePath} = info;
            let rotatedName = fileName.split(".txt")[0];
            let finalName = rotatedName.split("-")[2] + "." +  rotatedName.split("-")[1] + "." + rotatedName.split("-")[0];
            setFileName(finalName);

            filePath = filePath.replace("/logs/private/", "/logs/public/");
            let file = await getPublicFile(filePath);
            if(file) {
                setPublicFile(file);
            }
        });
    }
    let getPublicFile = async (filePath) => {
        // Ottiene tutti gli UUID dei file
        const filesResult = await ApiInterface.getFilesUUIDS(filePath);

        if(filesResult.length === 0) return null;
        if(filesResult.length > 1) return null;
        if(filesResult.length === 1) {
            return filesResult[0];
        }
    }

    useEffect(() => {
        ApiInterface.getFileUrl(uuid).then((url) => {
            fetch(url)
                .then(res => res.text())
                .then(text => {
                    const lines = text.split("\n").filter(Boolean);
                    setLogLines(lines);
                });
        });
        loadFileInfos();
    }, [uuid]);

    const handleSearch = (e) => {
        const value = e.target.value || "";
        setSearchTerm(value.toLowerCase());
    };

    const handleNameSearch = (e) => {
        const value = e.target.value || "";
        setNameSearch(value.toLowerCase());
    };

    const getFilteredLines = () => {
        return logLines.filter(line => {
            const timeMatch = line.match(/^(\d{2}:\d{2}:\d{2})/);
            const time = timeMatch ? timeMatch[1] : null;
            if (!time || time < startTime || time > endTime) return false;

            const msgMatch = line.match(/^(\d{2}:\d{2}:\d{2}) \[(.+?) -> (.+?)\] (.+)$/);
            if (!msgMatch) return false;

            const [, , from, to, message] = msgMatch;

            if (nameSearch) {
                const low = nameSearch.toLowerCase();
                if (!from.toLowerCase().includes(low) && !to.toLowerCase().includes(low)) return false;
            }

            if (searchTerm && !message.toLowerCase().includes(searchTerm)) return false;

            return true; // passa tutti i filtri
        });
    };

    const highlight = (text, term) => {
        if (!term) return text;
        const parts = text.split(new RegExp(`(${term})`, 'gi'));
        return parts.map((part, i) =>
            part.toLowerCase() === term ? <mark key={i}>{part}</mark> : part
        );
    };
    const highlightName = (text) => {
        if (!nameSearch) return text;
        const parts = text.split(new RegExp(`(${nameSearch})`, 'gi'));
        return parts.map((part, i) =>
            part.toLowerCase() === nameSearch ? <mark className={style.nameMark} key={i}>{part}</mark> : part
        );
    };

    return (
        <>
            <Background />
            <div className="page__body">
                <Header/>
                <div className={style.page__content}>
                    <div className={style.leftBox}>
                        <button onClick={() => window.location.href = "/logs/chats/private"}>
                            Torna a tutti i Log Privati
                        </button>
                        {fileName &&
                            <span> Stai guardando i log privati del <span className={style.fileName}>{fileName}</span> </span>
                        }
                        {publicFile &&
                            <button onClick={() => window.location.href = "/logs/chat/public/"+publicFile}>Vai al Log Pubblico</button>
                        }
                    </div>
                    <div className={style.filtersBox}>
                        <div className={style.timeFilters}>
                            <label>
                                Da:
                                <input
                                    type="time"
                                    value={startTime.slice(0, 5)}
                                    onChange={(e) => setStartTime(e.target.value + ":00")}
                                />
                            </label>
                            <label>
                                A:
                                <input
                                    type="time"
                                    value={endTime.slice(0, 5)}
                                    onChange={(e) => setEndTime(e.target.value + ":00")}
                                />
                            </label>
                        </div>

                        <input
                            type="text"
                            className={style.searchInput}
                            placeholder="Filtra per nome (da o a)..."
                            onChange={handleNameSearch}
                        />

                        <input
                            type="text"
                            className={style.searchInput}
                            placeholder="Cerca nel messaggio..."
                            onChange={handleSearch}
                        />
                    </div>

                    <div className={style.logContainer}>
                        {getFilteredLines().map((line, i) => {
                            const match = line.match(/^(\d{2}:\d{2}:\d{2}) \[(.+?) -> (.+?)\] (.+)$/);
                            if (!match) return null;

                            const [, time, from, to, message] = match;

                            return (
                                <div key={i} className={style.logLinePrivate}>
                                    <div className={style.time}>{time}</div>
                                    <div className={style.fromto}>
                                        <span>{highlightName(from)}</span>
                                        <span>↓  ↓</span>
                                        <span>{highlightName(to)}</span>
                                    </div>
                                    <div className={style.text}>
                                        {highlight(message, searchTerm)}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};

export default SingleLogChatPrivate;
